import { ApplicationActionType } from '../../actions/ActionType'

const initialState = {
    loading: false,
    objeckt:[]
}

type action = {
    type: string
    objeckt?: any
}

const ApplicationReducer = (state = initialState, action: action) => {
    switch (action.type) {
        case ApplicationActionType.Application_INIT:
            return {
                ...state,
                objeckt:action.objeckt,
                loading: true
            }
        default:
            return state
    }
}

export default ApplicationReducer
